import { configureStore, Action } from '@reduxjs/toolkit'
import storage from 'redux-persist/lib/storage'
import { persistReducer, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER, persistStore } from 'redux-persist'
import rootReducer from './rootReducer'
import { setupListeners } from '@reduxjs/toolkit/query'
import { ThunkAction } from 'redux-thunk'

const persistConfig = {
  key: 'root',
  debug: false,
  storage,
  // ALARMS IS ONLY WHITELISTED FOR DEVELOPMENT USE
  whitelist: ['auth', 'cognito', 'customers', 'alarms', 'widgets', 'users', 'remote'],
  // whitelist: ['auth', 'customers', 'locations'],
}

const persistedReducer = persistReducer(persistConfig, rootReducer)

export const store: any = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
        ignoredPaths: ['form'],
      },
    }),
})

//@ts-ignore
if (import.meta.env.VITE_NODE_ENV === 'development' && import.meta.hot) {
  import.meta.hot.accept('./rootReducer', async (_) => {
    const { default: newRootReducer } = await import('./rootReducer')
    store.replaceReducer(newRootReducer)
  })
}

type RootState = ReturnType<typeof store.getState>
export type AppThunk = ThunkAction<void, RootState, unknown, Action<string>>

export const persistor = persistStore(store)

setupListeners(store.dispatch)
